export default __webpack_public_path__ + "static/media/instagram-3x.9dcbe1fc.png";